export const getFormattedNumber = function(value: number | undefined | null): string {
  if (!value) {
    return '-';
  }
  return value.toFixed(2);
};
